import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService, notCloseMessageOptions } from '../../../core';
import { KPI_RAP } from '../../kpis';
import { DecimalComponent } from '../../../shared';
import { ClassificacaoFaturamento } from '../classificacao-faturamento';
import { ClassificacaoFaturamentoCrudHttpService, ClassificacaoFaturamentoCalculoService } from '../services';

@Component({
    selector: 'sgt-classificacao-faturamento-form',
    templateUrl: './classificacao-faturamento-form.component.html',
    styleUrls: ['./classificacao-faturamento-form.component.less']
})
export class ClassificacaoFaturamentoFormComponent implements BaseForm<ClassificacaoFaturamento>, OnInit {
    entity: ClassificacaoFaturamento;
    editMode: boolean;

    @ViewChild('form') form: NgForm;
    // Faturamento Mensal
    @ViewChild('valorFaturamentoMensalInicialDecimal') valorFaturamentoMensalInicialDecimal: DecimalComponent;
    @ViewChild('valorFaturamentoMensalFinalDecimal') valorFaturamentoMensalFinalDecimal: DecimalComponent;
    // Faturamento Anual
    @ViewChild('valorFaturamentoAnualInicialDecimal') valorFaturamentoAnualInicialDecimal: DecimalComponent;
    @ViewChild('valorFaturamentoAnualFinalDecimal') valorFaturamentoAnualFinalDecimal: DecimalComponent;
    // Valor Padrão RAP
    @ViewChild('valorPadraoRAPDecimal') valorPadraoRAPDecimal: DecimalComponent;


    // KPIs
    KPI_RAP = KPI_RAP;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private classificacaoFaturamentoHttpCrudService: ClassificacaoFaturamentoCrudHttpService,
                private classificacaoFaturamentoCalculoService: ClassificacaoFaturamentoCalculoService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        })
    }

    load(id: number) {
        this.classificacaoFaturamentoHttpCrudService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a classificação de faturamento', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new ClassificacaoFaturamento();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

    /** Ao alterar o valor inicial do faturamento mensal */
    onChangeValorFaturamentoMensalInicial() {
        // Calculando o valor inicial do faturamento anual
        this.entity.valorFaturamentoAnualInicial = this.classificacaoFaturamentoCalculoService.calcularValorFaturamentoAnual(this.entity.valorFaturamentoMensalInicial);
    }

    /** Ao alterar o valor final do faturamento mensal */
    onChangeValorFaturamentoMensalFinal() {
        // Calculando o valor final do faturamento anual
        this.entity.valorFaturamentoAnualFinal = this.classificacaoFaturamentoCalculoService.calcularValorFaturamentoAnual(this.entity.valorFaturamentoMensalFinal);
    }

    /** Ao alterar o valor inicial do faturamento anual */
    onChangeValorFaturamentoAnualInicial() {
        // Calculando o valor inicial do faturamento mensal
        // this.entity.valorFaturamentoMensalInicial = this.classificacaoFaturamentoCalculoService.calcularValorFaturamentoMensal(this.entity.valorFaturamentoAnualInicial);
    }

    /** Ao alterar o valor final do faturamento anual */
    onChangeValorFaturamentoAnualFinal() {
        // Calculando o valor final do faturamento mensal
        // this.entity.valorFaturamentoMensalFinal = this.classificacaoFaturamentoCalculoService.calcularValorFaturamentoMensal(this.entity.valorFaturamentoAnualFinal);
    }

    /** Valida se os valores do faturamento mensal estão válidos para salvar */
    private validateSaveValoresFaturamentoMensal(): boolean {
        // Valor inicial do faturamento mensal menor que zero
        if (this.entity.valorFaturamentoMensalInicial < 0) {
            this.messageService.warning('O valor inicial do faturamento mensal dever ser maior ou igual a 0,00. Ajuste o valor e tente salvar novamente', 'Atenção');
            this.valorFaturamentoMensalInicialDecimal?.setFocus();
            return false;
        }

        // Quando possuir o valor final do faturamento mensal
        if (this.entity.valorFaturamentoMensalFinal) {
            // Valor final do faturamento mensal menor que zero
            if (this.entity.valorFaturamentoMensalFinal < 0) {
                this.messageService.warning('O valor final do faturamento mensal dever ser maior ou igual a 0,00. Ajuste o valor e tente salvar novamente', 'Atenção');
                this.valorFaturamentoMensalFinalDecimal?.setFocus();
                return false;
            }
            // Sem o valor inicial do faturamento mensal
            if (this.entity.valorFaturamentoMensalInicial == null || this.entity.valorFaturamentoMensalInicial === undefined) {
                this.messageService.warning('É obrigatório informar o valor inicial do faturamento mensal quando o valor final estiver informado. Informe o valor inicial e tente salvar novamente', 'Atenção');
                return false;
            }
            // Valor inicial do faturamento mensal maior que o valor final
            if (this.entity.valorFaturamentoMensalInicial > this.entity.valorFaturamentoMensalFinal) {
                this.messageService.warning('O valor inicial do faturamento mensal não pode ser maior que o valor final. Ajuste os valores e tente salvar novamente', 'Atenção');
                this.valorFaturamentoMensalInicialDecimal?.setFocus();
                return false;
            }
        }

        return true;
    }

    /** Valida se os valores do faturamento anual estão válidos para salvar */
    private validateSaveValoresFaturamentoAnual(): boolean {
        // Valor inicial do faturamento anual menor que zero
        if (this.entity.valorFaturamentoAnualInicial < 0) {
            this.messageService.warning('O valor inicial do faturamento anual dever ser maior ou igual a 0,00. Ajuste o valor e tente salvar novamente', 'Atenção');
            this.valorFaturamentoAnualInicialDecimal?.setFocus();
            return false;
        }

        // Quando possuir o valor final do faturamento anual
        if (this.entity.valorFaturamentoAnualFinal) {
            // Valor final do faturamento anual menor que zero
            if (this.entity.valorFaturamentoAnualFinal < 0) {
                this.messageService.warning('O valor final do faturamento anual dever ser maior ou igual a 0,00. Ajuste o valor e tente salvar novamente', 'Atenção');
                this.valorFaturamentoAnualFinalDecimal?.setFocus();
                return false;
            }
            // Sem o valor inicial do faturamento anual
            if (this.entity.valorFaturamentoAnualInicial == null || this.entity.valorFaturamentoAnualInicial === undefined) {
                this.messageService.warning('É obrigatório informar o valor inicial do faturamento anual quando o valor final estiver informado. Informe o valor inicial e tente salvar novamente', 'Atenção');
                return false;
            }
            // Valor inicial do faturamento anual maior que o valor final
            if (this.entity.valorFaturamentoAnualInicial > this.entity.valorFaturamentoAnualFinal) {
                this.messageService.warning('O valor inicial do faturamento anual não pode ser maior que o valor final. Ajuste os valores e tente salvar novamente', 'Atenção');
                this.valorFaturamentoAnualInicialDecimal?.setFocus();
                return false;
            }
        }

        // Valor Padrão RAP
        if (this.entity.valorPadraoRAP) {
            // Valor Padrão RAP é menor que o valor anual inicial
            if (this.entity.valorPadraoRAP < this.entity.valorFaturamentoAnualInicial) {
                this.messageService.warning(`O Valor Padrão ${this.KPI_RAP.sigla} não pode ser menor que o valor inicial do faturamento anual. Informe um Valor Padrão ${this.KPI_RAP.sigla} maior ou igual ao valor do faturamento inicial e tente salvar novamente`, 'Atenção', notCloseMessageOptions);
                this.valorPadraoRAPDecimal?.setFocus();
                return false;
            }
            // Valor Padrão RAP é maior que o valor anual final
            if (this.entity.valorFaturamentoAnualFinal && (this.entity.valorPadraoRAP > this.entity.valorFaturamentoAnualFinal)) {
                this.messageService.warning(`O Valor Padrão ${this.KPI_RAP.sigla} não pode ser maior que o valor final do faturamento anual. Informe um Valor Padrão ${this.KPI_RAP.sigla} menor ou igual ao valor do faturamento final e tente salvar novamente`, 'Atenção', notCloseMessageOptions);
                this.valorPadraoRAPDecimal?.setFocus();
                return false;
            }
        }

        return true;
    }

    /** Valida o save */
    private validateSave(): boolean {
        // Faturamento mensal
        if (!this.validateSaveValoresFaturamentoMensal()) {
            return false;
        }
        // Faturamento anual
        if (!this.validateSaveValoresFaturamentoAnual()) {
            return false;
        }

        return true;
    }


    save() {
        if (!this.validateSave()) {
            return;
        }

        this.baseFormService.save<ClassificacaoFaturamento>(this.entity, this.form, this.editMode, this.classificacaoFaturamentoHttpCrudService)
            .then(entity => {
                this.messageService.success('', 'Classificação de Faturamento salva com sucesso');
                this.afterSave(entity);
            })
            .catch(error => {});
    }

    afterSave(entity: ClassificacaoFaturamento) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
